export default function NewsPage(props) {
	return (
		<div className="relative bg-sky-800 w-full h-screen overflow-hidden flex items-center justify-center ">
			<div className="absolute flex flex-col gap-4">
				<h1>News page</h1>
			</div>
		</div>
	);
}
